import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { map, switchMap, take } from 'rxjs/operators';

export const roleGuard = (requiredRole: string[]): CanActivateFn => {
  return () => {
    const auth = inject(AuthService);
    const router = inject(Router);

    // 1. Wait for the core authentication state to resolve first
    return auth.isAuthenticated().pipe(
      take(1),
      // 2. Once auth state is known, grab the current user data
      switchMap(() => auth.user$.pipe(take(1))),
      // 3. Now safely check the roles
      map(user => {
        if (user?.role && requiredRole.includes(user.role)) {
          return true; // Allow access
        }

        // Role mismatch → redirect
        router.navigate(['/unauthorized']);
        return false;
      })
    );
  };
};
